import React, { useCallback, useEffect, useState } from 'react';
import '../FieldSample.scss';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import { getSubSamples } from 'src/apis/getFuelSampleCalls';
import { RoundDecimal2, ValidCharacters, errorResponse, fieldSampleAreaEditor, preventMinus, validateCharacters } from 'src/store/common';
import { Button, Modal, TextField, Tooltip } from '@mui/material';
import { useStoreContext } from 'src/store/context';
import { checkWeightsAndValue, createUpdateSample, createUpdateSubSample, deleteSample, deleteSubSample} from 'src/apis/mutationsFuelSample';
import { useAddAlert } from 'src/store/actions';
import LoadingSpinner from 'src/shared/loading/loading';
import { Grid } from 'src/shared/grid';
import moment from 'moment';
import { StyledTableCell, StyledTableCell2, StyledTableRow, StyledTableRow2, modalStyle } from 'src/shared/Styles/Styles';
import { AuditLog } from '../Audit';
import { alertMessages } from 'src/constants';

type SampleAndSubSamplesRowProp = {
    varsAndFuncsFieldSampleChild: any
}
let deleteSubSampleCalled = false;
let deleteSampleCalled = false;


export const SampleAndSubSamplesRow: React.FC<SampleAndSubSamplesRowProp>= ({varsAndFuncsFieldSampleChild })=> {
    const [open, setOpen] = useState(varsAndFuncsFieldSampleChild.sample.sub_opened);
    const [subSamples, setSubSamples] = useState<any[]>([]);
    const [state, setState] = useStoreContext();
    const addAlert = useAddAlert(setState);
    const [subSampleCalled, setSubSampleCalled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const STATUS_SUBMITTED = 'Submitted';
    const STATUS_EDITED = 'Edited';
    const STATUS_ARCHIVED = 'Archived';
    const STATUS_DRAFT = 'Draft';


    const [openAudit, setOpenAudit] = useState(false);
    const handleOpenAudit = () => setOpenAudit(true);
    const handleCloseAudit= (event, reason) => {
      setOpenAudit(false);
    }

    const [error, setError] = useState<boolean>(false);
    /* Edit sub sample is onClick handler*/
    const editSubSample =(indexParent: number, indexChild: number,indexSub:number, setSubSamples: any, subSamples: any)=>{
        const allSamples = [...varsAndFuncsFieldSampleChild.allSamps];
        allSamples[indexParent].samples[indexChild].subsamples[indexSub].sub_editing = true;
        varsAndFuncsFieldSampleChild.setAllSamps(allSamples);
        const editingSubSamples = [...subSamples];
        editingSubSamples[indexSub] ={
          ...subSamples[indexSub],
          sub_editing : true,
          error_wet: '',
          error_dry: '',
          error_tare: '',
          error_value: '',
        }
        setSubSamples(editingSubSamples);
    };

    /* on Submit Sample will submit the sample by setting a variable that has
     been to this child so that Submit component can use it
     */
    const onSubmitSample = (sample:any) =>{
        varsAndFuncsFieldSampleChild.setOpenSubmitModal(true);
        const sampleToUpdate ={
          siteId: sample.site_id,
          fuel_sample_id: sample.fuel_sample_id,
          sampleType: sample.fuel.fuel_type,
          sampleCategory:sample.fuel.category,
          sampleMethod: sample.method_type,
          sampleSubCategory: sample.sub_category,
          sample_status: STATUS_SUBMITTED,
          sampleDate: sample.sample,
          sample_average_value: sample.sample_average_value
        }

        const variableForSubmit ={
          sample: sampleToUpdate,
          subsamples: sample.subsamples,
          token: varsAndFuncsFieldSampleChild.token,
          setAddSampleCalled: varsAndFuncsFieldSampleChild.setAddSampleCalled
        }
        varsAndFuncsFieldSampleChild.setSampleToSubmit(variableForSubmit)
    }

    /* on Delete Sample will handle when on Delete is pressed*/
    const onDeleteSample = (sample: any, indexParent:number, indexChild: number) =>{
      if(sample.status.includes(STATUS_DRAFT)){
        varsAndFuncsFieldSampleChild.setArchivedVerbiage(false);
      }
      else{
        varsAndFuncsFieldSampleChild.setArchivedVerbiage(true);
      }
        varsAndFuncsFieldSampleChild.setTypeToDelete('sample');
        const sampleToDelete ={
          indexParent: indexParent,
          indexChild: indexChild,
          sample: sample,
        }
        varsAndFuncsFieldSampleChild.setParamsForGetSamplesCallBack(varsAndFuncsFieldSampleChild.row)
        varsAndFuncsFieldSampleChild.setOpenDeleteModal(true);
        varsAndFuncsFieldSampleChild.setSampleToDelete(sampleToDelete);
    }

    /* on Delete Sub sample is when delete subsample is pressed, it takes in the subsample 
    information, index of the header and index of the sample so it can find the subsample index*/
    const onDeleteSubSample = (subsample:any, indexParent:number, indexChild: number)=>{
      if(subsample.status.includes(STATUS_DRAFT)){
        varsAndFuncsFieldSampleChild.setArchivedVerbiage(false);
      }
      else{
        varsAndFuncsFieldSampleChild.setArchivedVerbiage(true);
      }
      varsAndFuncsFieldSampleChild.setTypeToDelete('subsample');

      varsAndFuncsFieldSampleChild.setOpenDeleteModal(true);
      varsAndFuncsFieldSampleChild.setSubSampleIdToDelete(subsample.fuel_sub_sample_id);
      varsAndFuncsFieldSampleChild.setSampleToReload({
        indexParent: indexParent, 
        indexChild: indexChild, 
        sample: varsAndFuncsFieldSampleChild.sample
      });
    }

    /* Add Sub Sample is the i*/
    const addSubSample =(subSamples:any[], index: number, indexchild:number, setSubSamples:any)=>{
        const allSamples = [...varsAndFuncsFieldSampleChild.allSamps];
        const newSubSample={
          fuel_sample_id: allSamples[index].samples[indexchild].fuel_sample_id,
          wet_weight: null, 
          dry_weight: null, 
          tar_weight: null, 
          sample_average_value: null, 
          container_id: null,
          status: STATUS_DRAFT,
          sub_editing: true,
          added_but_not_saved_db: true,
          error_wet: '',
          error_dry: '',
          error_tare: '',
          error_value: '',
        };
        let allSubSamples = [...subSamples];
        allSubSamples.push(newSubSample);
        setSubSamples(allSubSamples);
        allSamples[index].samples[indexchild].add_sub_clicked = true;
        allSamples[index].samples[indexchild].subsamples = allSubSamples;
        varsAndFuncsFieldSampleChild.setAllSamps(allSamples);
    }

    /* when a user is done editing the sample this handler will trigger
    where it will update the samples and make calculations so it will update the screen 
    and make calls to the create sample
    and get sub sample call*/
    const handleDoneEdit = (subsample:any, indexParent: number, indexChild: number, indexSub: number) =>{
      (async()=>{
        try{
          setLoading(true);
          const allSamples = [...varsAndFuncsFieldSampleChild.allSamps];

          const parameterToSubSample = {
            subsamples: [
            {
              tarWeight: Number(subsample.tar_weight),
              dryWeight: Number(subsample.dry_weight),
              wetWeight: Number(subsample.wet_weight),
              sampleAverageValue: checkWeightsAndValue(subsample.tar_weight, subsample.dry_weight, subsample.wet_weight, subsample.sample_average_value),
              fuelSubSampleId: Number(subsample.fuel_sub_sample_id),
              status: subsample.status,
              containerId: subsample.container_id
            }],
            sampleId: subsample.fuel_sample_id
          }
          /*call for a single subsample save*/
          const returnFromPromise:any = await createUpdateSubSample(varsAndFuncsFieldSampleChild.token, addAlert, parameterToSubSample);
          if(returnFromPromise){
            allSamples[indexParent].samples[indexChild].subsamples[indexSub].sub_editing = false;
            allSamples[indexParent].samples[indexChild].subsamples[indexSub].added_but_not_saved_db = false;
            allSamples[indexParent].samples[indexChild].add_sub_clicked = false;
            setSubSamples(allSamples[indexParent].samples[indexChild].subsamples);

            allSamples[indexParent].samples[indexChild].subsamples[indexSub].status = returnFromPromise[0].status;
            allSamples[indexParent].samples[indexChild].subsamples[indexSub].sample_average_value= returnFromPromise[0].sample_average_value;
            varsAndFuncsFieldSampleChild.setAllSamps(allSamples);   
            const currentStatusOfSample = allSamples[indexParent].samples[indexChild].status
            if(currentStatusOfSample.includes(STATUS_SUBMITTED)){
              allSamples[indexParent].samples[indexChild].status = STATUS_EDITED;
            }

            /*calculations for sample_average_value of sample*/
            let allSubSamples = [...allSamples[indexParent].samples[indexChild].subsamples];
            let sampleSum = 0;
            let countSampleComplete =0;
            let sampleAvg:number|null =0;
            allSubSamples.forEach((sub)=>{
              if(sub.status.includes('Complete')){
                countSampleComplete=countSampleComplete +1;
                sampleSum = sampleSum + Number(sub.sample_average_value);
              }
            })
            sampleAvg = sampleSum/countSampleComplete;
            if(Number.isNaN(sampleAvg)){
              sampleAvg=0;
            }
            if(countSampleComplete ===0){
              allSamples[indexParent].samples[indexChild].sample_average_value = 0;
            }
            else{
              allSamples[indexParent].samples[indexChild].sample_average_value = sampleAvg;
            }

            /* parameters to send to update the sample that sub sample is editing*/
            const parameterToSend ={
              siteId: allSamples[indexParent].samples[indexChild].site_id,
              fuel_sample_id: allSamples[indexParent].samples[indexChild].fuel_sample_id,
              sampleType: allSamples[indexParent].samples[indexChild].fuel.fuel_type,
              sampleCategory: allSamples[indexParent].samples[indexChild].fuel.category,
              sampleMethod: allSamples[indexParent].samples[indexChild].method_type,
              sampleSubCategory: allSamples[indexParent].samples[indexChild].sub_category,
              sample_status: currentStatusOfSample.includes(STATUS_SUBMITTED)? STATUS_EDITED: STATUS_DRAFT,
              sampleDate: allSamples[indexParent].samples[indexChild].sample,
              sample_average_value: allSamples[indexParent].samples[indexChild].sample_average_value
            }
            createUpdateSample(null, parameterToSend, varsAndFuncsFieldSampleChild.setAddSampleCalled, true, addAlert);
            subSampleResponseHandle(varsAndFuncsFieldSampleChild.sample.fuel_sample_id, subSamples, false);
            setLoading(false)
          }
          else{
            setLoading(false)
          }
        }
        catch (error: any) {
          if (error?.toString()?.includes('duplicate')) {
            errorResponse(error, addAlert, error);
          }
          else {
            errorResponse(error, addAlert, alertMessages.fieldSampleSave);
          }

          setLoading(false)
        } 
      })();
    }

    const saveAllSubSamples = (indexParent: number, indexChild: number) =>{
      (async()=>{
        try{
          setLoading(true)
          const allSamples = [...varsAndFuncsFieldSampleChild.allSamps];
          allSamples[indexParent].samples[indexChild].add_sub_clicked = false;
          const currSubSamples = subSamples;
          let subSamplesToSave:any[] = [];
          let sampId: any = null;
          
          currSubSamples.forEach((currSub)=>{
            subSamplesToSave.push({
              tarWeight: Number(currSub.tar_weight),
              dryWeight: Number(currSub.dry_weight),
              wetWeight: Number(currSub.wet_weight),
              sampleAverageValue: checkWeightsAndValue(currSub.tar_weight, currSub.dry_weight, currSub.wet_weight, currSub.sample_average_value),
              fuelSubSampleId: Number(currSub.fuel_sub_sample_id),
              status: currSub.status,
              containerId: currSub.container_id              
            });
            sampId = currSub.fuel_sample_id
          })
          const parametersToSubUpdate = {
            subsamples: subSamplesToSave,
            sampleId: sampId
          }
          const returnFromPromise:any = await createUpdateSubSample(varsAndFuncsFieldSampleChild.token, addAlert, parametersToSubUpdate);
          if(returnFromPromise){
            allSamples[indexParent].samples[indexChild].subsamples.forEach((sub, i)=>{
              returnFromPromise.forEach((returnedSub, j)=>{
                if(i===j){
                  allSamples[indexParent].samples[indexChild].subsamples[i].status = returnedSub.status
                  allSamples[indexParent].samples[indexChild].subsamples[i].sample_average_value = returnedSub.sample_average_value
                }
                allSamples[indexParent].samples[indexChild].subsamples[i].sub_editing = false;
                allSamples[indexParent].samples[indexChild].subsamples[i].added_but_not_saved_db=false;
              })
            });
            varsAndFuncsFieldSampleChild.setAllSamps(allSamples);   
            const currentStatusOfSample = allSamples[indexParent].samples[indexChild].status
            if(currentStatusOfSample.includes(STATUS_SUBMITTED)){
              allSamples[indexParent].samples[indexChild].status = STATUS_EDITED;
            }

            /*calculations for sample_average_value of sample*/
            let allSubSamples = [...allSamples[indexParent].samples[indexChild].subsamples];
            let sampleSum = 0;
            let countSampleComplete =0;
            let sampleAvg:number|null =0;
            allSubSamples.forEach((sub)=>{
              if(sub.status.includes('Complete')){
                countSampleComplete=countSampleComplete +1;
                sampleSum = sampleSum + Number(sub.sample_average_value);
              }
            })
            sampleAvg = sampleSum/countSampleComplete;
            if(Number.isNaN(sampleAvg)){
              sampleAvg=0;
            }
            if(countSampleComplete ===0){
              allSamples[indexParent].samples[indexChild].sample_average_value = 0;
            }
            else{
              allSamples[indexParent].samples[indexChild].sample_average_value = sampleAvg;
            }
            subSampleResponseHandle(varsAndFuncsFieldSampleChild.sample.fuel_sample_id, subSamples, false);
            setLoading(false);
          }
          else{
            setLoading(false);
          }
        }
        catch(error){
          errorResponse(error, addAlert, alertMessages.fieldSampleSave);

          setLoading(false);
        } 
      })();
    }
        /* sub sample response handle will handle the response from get subsamples
    it adds in a sub_editing field that is a boolean to indicate whether a sub sample edit/add button has
    been pressed
    
    */

    const subSampleResponseHandle =useCallback(async(sample_id: number, currentSubSamples: any, fromOpenSub:boolean)=>{
      try{
        let filteredForEditingSubs: any[]=[];
        if(fromOpenSub){
          if(currentSubSamples.length>0){
            filteredForEditingSubs = currentSubSamples.filter((sub:any)=>sub.sub_editing)
            if(filteredForEditingSubs.length>0){
              return;
            }
          }
        }
        
        const subResponse:any = await getSubSamples(varsAndFuncsFieldSampleChild.token, sample_id);
        const allSamples = [...varsAndFuncsFieldSampleChild.allSamps];
        let subs: any[] = [];
        if(subResponse.length>0){
          subResponse.forEach((subR:any)=>{
            if(allSamples[varsAndFuncsFieldSampleChild.index].samples[varsAndFuncsFieldSampleChild.indexchild].subsamples){
              allSamples[varsAndFuncsFieldSampleChild.index].samples[varsAndFuncsFieldSampleChild.indexchild].subsamples.forEach((subState:any)=>{
                if(subState.fuel_sub_sample_id===subR.fuel_sub_sample_id){
                  subR.sub_editing = subState.sub_editing
                }
              })
            }
            else{
              subR.sub_editing = false
            }
          })
          if(fieldSampleAreaEditor(state.user)){
            subs = subResponse;
          }
          else{
            subs = subResponse.filter((sub:any)=>!sub.status.includes(STATUS_ARCHIVED));
          }
        }
        allSamples[varsAndFuncsFieldSampleChild.index].samples[varsAndFuncsFieldSampleChild.indexchild].subsamples = subs;
        varsAndFuncsFieldSampleChild.setAllSamps(allSamples);
        setSubSamples(subs);     
      }
      catch(error){
        errorResponse(error, addAlert, alertMessages.fieldSampleHomeData);
      } 
    },[addAlert, varsAndFuncsFieldSampleChild, state.user]);

    /* delete sub sample will make a call to delete a sub sample
      it will then need to make a call to createupdate sample so it can update the 
      status of sample_average_value
    */
    const deleteSubSampleResponse =async(sub_sample_id: number, sampleReload:any)=>{
      deleteSubSampleCalled = true;
      setLoading(true);
      try{
        const booleanReponseFromDeleteSubSample:any = await deleteSubSample(varsAndFuncsFieldSampleChild.token, addAlert, sub_sample_id);
        if(booleanReponseFromDeleteSubSample){
            const allSamples = [...varsAndFuncsFieldSampleChild.allSamps];
            let sampleSum = 0;
            let countSampleComplete =0;
            let sampleAvg =0;
            const sampleHeaderIndex = sampleReload.indexParent;
            const sampleIndex = sampleReload.indexChild;
            let allSubSamples = [...allSamples[sampleHeaderIndex].samples[sampleIndex].subsamples];
            const filterOutRemoval = allSubSamples.filter((sub)=>sub.fuel_sub_sample_id!==sub_sample_id);
            const currentStatusOfSample = allSamples[sampleHeaderIndex].samples[sampleIndex].status
            if(currentStatusOfSample.includes(STATUS_ARCHIVED)){
              allSamples[sampleHeaderIndex].samples[sampleIndex].status = STATUS_EDITED;
            }

            /* filter out the array object that was removed and if it no longer has a length then need to change it
              back to draft
            */
            if(filterOutRemoval.length<=0){
              allSamples[sampleHeaderIndex].samples[sampleIndex].status = STATUS_EDITED;
              allSamples[sampleHeaderIndex].samples[sampleIndex].sample_average_value =0;
              varsAndFuncsFieldSampleChild.setAllSamps(allSamples);  
            }  
            else{
              filterOutRemoval?.forEach((sub)=>{
                if(sub.status.includes('Complete')){
                  countSampleComplete=countSampleComplete +1;
                  sampleSum = sampleSum + Number(sub.sample_average_value);
                }
              })
            }          
            
            sampleAvg = sampleSum/countSampleComplete;
            if(Number.isNaN(sampleAvg)){
              sampleAvg=0;
            }
            if(countSampleComplete ===0){
              allSamples[sampleHeaderIndex].samples[sampleIndex].sample_average_value = 0;
            }
            else{
              allSamples[sampleHeaderIndex].samples[sampleIndex].sample_average_value = sampleAvg;
            }
            subSampleResponseHandle(allSamples[sampleHeaderIndex].samples[sampleIndex].fuel_sample_id,subSamples, false);
            varsAndFuncsFieldSampleChild.setSampleToReload()
            setLoading(false)
            deleteSubSampleCalled=false;
            varsAndFuncsFieldSampleChild.setTypeToDelete('')
        }
        else{
          const allSamples = [...varsAndFuncsFieldSampleChild.allSamps];
          const sampleHeaderIndex = sampleReload.indexParent;
          const sampleIndex = sampleReload.indexChild;
          const currentStatusOfSample = allSamples[sampleHeaderIndex].samples[sampleIndex].status
          if(currentStatusOfSample.includes(STATUS_DRAFT)){
            errorResponse(booleanReponseFromDeleteSubSample, addAlert, alertMessages.fieldSampleDelete);

          }
          else{
            errorResponse(booleanReponseFromDeleteSubSample, addAlert, alertMessages.fieldSampleArchive);
          }
          setLoading(false);
          varsAndFuncsFieldSampleChild.setTypeToDelete('')
          deleteSubSampleCalled=false

        }
      }
      catch(error){
        const allSamples = [...varsAndFuncsFieldSampleChild.allSamps];
        const sampleHeaderIndex = sampleReload.indexParent;
        const sampleIndex = sampleReload.indexChild;
        const currentStatusOfSample = allSamples[sampleHeaderIndex].samples[sampleIndex].status
        if(currentStatusOfSample.includes(STATUS_DRAFT)){
          errorResponse(error, addAlert, alertMessages.fieldSampleDelete);

        }
        else{
          errorResponse(error, addAlert, alertMessages.fieldSampleArchive);
        }
        varsAndFuncsFieldSampleChild.setTypeToDelete('')
        deleteSubSampleCalled=false
      } 
    };
    const openSubSample =()=>{
      setOpen(!open);
      setSubSampleCalled(true);
      if(varsAndFuncsFieldSampleChild.allSamps[varsAndFuncsFieldSampleChild.index].samples){
        varsAndFuncsFieldSampleChild.allSamps[varsAndFuncsFieldSampleChild.index].samples[varsAndFuncsFieldSampleChild.indexchild].sub_opened = !open;
      }
      else{
        varsAndFuncsFieldSampleChild.allSamps[varsAndFuncsFieldSampleChild.index].samples = [varsAndFuncsFieldSampleChild.sample]
        varsAndFuncsFieldSampleChild.allSamps[varsAndFuncsFieldSampleChild.index].samples[varsAndFuncsFieldSampleChild.indexchild].sub_opened = !open;
      }
      if(open!==true){
        subSampleResponseHandle(varsAndFuncsFieldSampleChild.sample.fuel_sample_id, subSamples, true);
      }
    }



    /* this method is used to update input of a subsample. It will handle when users enter
    values into the weight or value fields*/
    const updateInputSub = (setSubSamples: any, subSamples: any, indexSub:number, value: any, fieldName:string)=>{
      if(value.length ===1 && /^\s/.test(value)){
        return
      }

      let editingSubSamples = [...subSamples];
      const helperText= 'The weight(s) entered are not valid';

      /*below is an if statement to check if the update is coming from the weights or value so it can do calculations */
      if(fieldName===('wet_weight')){
        const dry = editingSubSamples[indexSub].dry_weight;
        const tar = editingSubSamples[indexSub].tar_weight;
        if(Number(dry)> Number(value)|| Number(tar)>Number(value) || Number(tar)>Number(dry)){
          if(Number(dry)> Number(value)){
            editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_wet: helperText, error_dry: helperText};
          }
          else{
            editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_wet: helperText, error_dry: helperText, error_tare: helperText};
          }
        }
        else{
          editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_wet: '', error_dry: '', error_tare: ''};
        }
        if(dry &&  tar){
          const dryNum: number = Number(dry);
          const tarNum: number = Number(tar);
          if(value.length!==0){
            const calculatedValue = Number((((Number(value)-dryNum)/(dryNum -tarNum)) *100).toFixed(2));
            if(Number.isFinite(calculatedValue)){
              editingSubSamples[indexSub] = {...editingSubSamples[indexSub], sample_average_value: calculatedValue, wet_weight: value}
              if(calculatedValue<0){
                editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_value: 'Cannot have a negative Value'};
              }
              else{
                editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_value: ''};
              }
            }
            else{
              editingSubSamples[indexSub] = {...editingSubSamples[indexSub], [fieldName]: value, sample_average_value:'', error_value: 'Cannot have infinite Value'}
            }
          }
          else{
            editingSubSamples[indexSub] = {...editingSubSamples[indexSub], [fieldName]: value, error_value: ''}
          }
        }
        else{
          editingSubSamples[indexSub] = {...editingSubSamples[indexSub], [fieldName]: value, error_value: ''}
        }
      }
      else if(fieldName===('dry_weight')){
        const wet = editingSubSamples[indexSub].wet_weight;
        const tar = editingSubSamples[indexSub].tar_weight;
        if(Number(value)> Number(wet)|| Number(tar)>Number(value) || Number(tar)>Number(wet)){
          if(Number(value)> Number(wet)){
            editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_wet: helperText, error_dry: helperText};
          }
          else{
            editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_wet: helperText, error_dry: helperText, error_tare: helperText};
          }
        }
        else{
          editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_wet: '', error_dry: '', error_tare: ''};
        }
        if(wet && tar){
          const wetNum: number = Number(wet);
          const tarNum: number = Number(tar);
          if(value.length!==0){
            const calculatedValue = Number((((wetNum - Number(value))/(Number(value) -tarNum)) *100).toFixed(2));
            if(Number.isFinite(calculatedValue)){
              editingSubSamples[indexSub] = {...editingSubSamples[indexSub], sample_average_value: calculatedValue, dry_weight: value};
              if(calculatedValue<0){
                editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_value: 'Cannot have a negative Value'};
              }
              else{
                editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_value: ''};
              }
            }
            else{
              editingSubSamples[indexSub] = {...editingSubSamples[indexSub], [fieldName]: value, sample_average_value: '', error_value: 'Cannot have infinite value'}
            }
          }
          else{
            editingSubSamples[indexSub] = {...editingSubSamples[indexSub], [fieldName]: value, error_value: ''}
          }
        }
        else{
          editingSubSamples[indexSub] = {...editingSubSamples[indexSub], [fieldName]: value, error_value: ''}
        }
      }
      else if(fieldName===('tar_weight')){
        const wet = editingSubSamples[indexSub].wet_weight;
        const dry = editingSubSamples[indexSub].dry_weight;
        if(Number(value)>Number(wet) || Number(value)>Number(dry)){
          editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_wet: helperText, error_dry: helperText, error_tare: helperText};
        }
        else{
          editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_wet: '', error_dry: '', error_tare: ''};
        }
        if(dry && wet){
          const wetNum: number = Number(wet);
          const dryNum: number = Number(dry);
          if(value.length!==0){
            const calculatedValue = Number((((wetNum - dryNum)/(dryNum -Number(value))) *100).toFixed(2));
            if(Number.isFinite(calculatedValue)){
              editingSubSamples[indexSub] = {...editingSubSamples[indexSub], sample_average_value: calculatedValue, tar_weight: value}
              if(calculatedValue<0){
                editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_value: 'Cannot have a negative Value'};
              }
              else{
                editingSubSamples[indexSub]={...editingSubSamples[indexSub], error_value: ''};
              }
            }
            else{
              editingSubSamples[indexSub] = {...editingSubSamples[indexSub], [fieldName]: value, sample_average_value:'', error_value: 'Cannot have infinite Value'}
            }
          }
          else{
            editingSubSamples[indexSub] = {...editingSubSamples[indexSub], [fieldName]: value, sample_average_value: '', error_value: ''}
          }
        }
        else{
          editingSubSamples[indexSub] = {...editingSubSamples[indexSub], [fieldName]: value, error_value: ''}
        }
      }
      else if(fieldName==='container_id'){
        editingSubSamples[indexSub] = {...subSamples[indexSub], [fieldName]: value}
        setSubSamples(editingSubSamples);

      }
      else{
        const regex = /^\d*\.?\d{0,2}$/;
        if(regex.test(value) || value===''){
          editingSubSamples[indexSub] = {...subSamples[indexSub], [fieldName]: value, error_value: ''}
        }
      }

      if(editingSubSamples[indexSub].error_dry.length>1 ||
        editingSubSamples[indexSub].error_wet.length>1 ||
        editingSubSamples[indexSub].error_tare.length>1 ||
        editingSubSamples[indexSub].error_value.length>1
        ){
          setError(true);
      }
      else{
        setError(false);
      }
      setSubSamples(editingSubSamples);
    };
    
    const deleteSampleResponse = async(sample: any)=>{
      deleteSampleCalled=true;
      setLoading(true);
      try{
        const responseAfterDeleteSample= await deleteSample(varsAndFuncsFieldSampleChild.token, addAlert, sample.sample.fuel_sample_id);
        if(responseAfterDeleteSample){
          const sampleHeaderIndex = sample.indexParent;
          const allSampleHeader = [...varsAndFuncsFieldSampleChild.allSamps];
          let allSamplesForThisHeader = [...allSampleHeader[sampleHeaderIndex].samples];
          if(allSamplesForThisHeader.length<2){
            if(sample?.sample?.status.includes(STATUS_DRAFT)){
              varsAndFuncsFieldSampleChild.setCallBackToBeMade({
                type: 'getHeaders', sample: sample, archived: false
              });
            }
            else{
              varsAndFuncsFieldSampleChild.setCallBackToBeMade({
                type: 'getHeaders', sample: sample, archived: true
              });
            }
          }
          else{
            if(sample?.sample?.status.includes(STATUS_DRAFT)){
              varsAndFuncsFieldSampleChild.setCallBackToBeMade({
                type:'getSamples', sample:sample, archived: false, paramsForGetSamplesCallBack: varsAndFuncsFieldSampleChild.paramsForGetSamplesCallBack
              });
            }
            else{
              varsAndFuncsFieldSampleChild.setCallBackToBeMade({
                type:'getSamples', sample:sample,archived:true, paramsForGetSamplesCallBack: varsAndFuncsFieldSampleChild.paramsForGetSamplesCallBack
              });
            }
          }

          varsAndFuncsFieldSampleChild.setTypeToDelete('');
          deleteSampleCalled=false;

        }
        else{
          if(sample?.sample?.status.includes(STATUS_DRAFT)){
            errorResponse(responseAfterDeleteSample, addAlert, alertMessages.fieldSampleDelete);

          }
          else{
            errorResponse(responseAfterDeleteSample, addAlert, alertMessages.fieldSampleArchive);

          }
          setLoading(false);
          varsAndFuncsFieldSampleChild.setTypeToDelete('')
          deleteSampleCalled=false
        }
        varsAndFuncsFieldSampleChild.setTypeToDelete('')
      }
      catch(error){
        if(sample?.sample?.status.includes(STATUS_DRAFT)){
          errorResponse(error, addAlert, alertMessages.fieldSampleDelete);

        }
        else{
          errorResponse(error, addAlert, alertMessages.fieldSampleArchive);
        }        
        varsAndFuncsFieldSampleChild.setTypeToDelete('')
        deleteSampleCalled=false
      } 
    };

    /* this is a check, it will check if sample was clicked so it will store the subsamples that were already called*/
    useEffect(()=>{
      if(varsAndFuncsFieldSampleChild.sample.sub_opened && subSamples.length<1 && !subSampleCalled){
        if(varsAndFuncsFieldSampleChild.allSamps){
          if(varsAndFuncsFieldSampleChild.allSamps[varsAndFuncsFieldSampleChild.index].samples){
            const sample = varsAndFuncsFieldSampleChild.allSamps[varsAndFuncsFieldSampleChild.index].samples[varsAndFuncsFieldSampleChild.indexchild];
            if(sample?.subsamples){
              setSubSamples(sample.subsamples)
              setSubSampleCalled(true);
            }
          }
        }
  
      }
    },[subSampleCalled, subSamples.length, varsAndFuncsFieldSampleChild.allSamps, varsAndFuncsFieldSampleChild.index,
      varsAndFuncsFieldSampleChild.indexchild, varsAndFuncsFieldSampleChild.sample
    ])

    /* This will interact with the delete modal. If the delete modal has set the deletepressed to true this will trigger
    if the type to delete is a subsample it will make a call to delete subsample
    */
    const sampleIdMatch = () =>{
      if(varsAndFuncsFieldSampleChild.sampleToReload.sample.fuel_sample_id === varsAndFuncsFieldSampleChild.sample.fuel_sample_id){
        varsAndFuncsFieldSampleChild.setDeletePressed(false);
        deleteSubSampleResponse(varsAndFuncsFieldSampleChild.subSampleIdToDelete, varsAndFuncsFieldSampleChild.sampleToReload);
      }
    }
    const subSampleDeleteChecksFromModal = () =>{
      if(varsAndFuncsFieldSampleChild.typeToDelete==='subsample'){
        /* This will interact with the delete modal. If the delete modal has set the deletepressed to true this will trigger*/
        if(varsAndFuncsFieldSampleChild.deletePressed && !deleteSubSampleCalled){
          sampleIdMatch();
        }
      }
    }
    subSampleDeleteChecksFromModal();
    const sampleDeleteChecksFromModal=()=>{
    /*if the type to delete is sample it will make a call to delete sample*/
    if(varsAndFuncsFieldSampleChild.typeToDelete==='sample'){
      if(varsAndFuncsFieldSampleChild.deletePressed && !deleteSampleCalled){
        deleteSampleResponse(varsAndFuncsFieldSampleChild.sampleToDelete)
        varsAndFuncsFieldSampleChild.setDeletePressed(false);
      }
    }  
    }
    sampleDeleteChecksFromModal();

    /* this will handle a cancel editing*/
    const cancelEditing = ( indexParent: number, indexChild: number,indexSub:number, setSubSamples:any, subSamples:any, subSamp:any) =>{
      const allSamples = [...varsAndFuncsFieldSampleChild.allSamps];
      allSamples[indexParent].samples[indexChild].subsamples[indexSub].sub_editing = false;
      if(subSamp){
        if(subSamp.added_but_not_saved_db){
          let newSubSamplesArray = [...subSamples];
          newSubSamplesArray.pop();
          setSubSamples(newSubSamplesArray);
          allSamples[indexParent].samples[indexChild].subsamples = newSubSamplesArray;
          allSamples[indexParent].samples[indexChild].add_sub_clicked = false;
          varsAndFuncsFieldSampleChild.setAllSamps(allSamples);
        }
        else{
          let editingSubSamples = [...subSamples]
          editingSubSamples[indexSub] = {
            ...subSamples[indexSub],
            wet_weight: allSamples[indexParent].samples[indexChild].subsamples[indexSub].wet_weight,
            dry_weight: allSamples[indexParent].samples[indexChild].subsamples[indexSub].dry_weight,
            tar_weight: allSamples[indexParent].samples[indexChild].subsamples[indexSub].tar_weight,
            sample_average_value: allSamples[indexParent].samples[indexChild].subsamples[indexSub].sample_average_value,
            container_id: allSamples[indexParent].samples[indexChild].subsamples[indexSub].container_id,
            sub_editing: false,
            error_wet: '',
            error_dry: '',
            error_tare: '',
            error_value: '',
          }
          setSubSamples(editingSubSamples);
          varsAndFuncsFieldSampleChild.setAllSamps(allSamples);
        }
      }
    }

    /* THIS WILL CHECK IF ANY OF THE SUBSAMPLES HAVE A STATUS OF COMPLETE */
    const checkIfAllComplete = ()=>{
      if(subSamples.length>0){
        const findDraft = subSamples.find((sub:any)=> sub.status.includes(STATUS_DRAFT))
        if(findDraft){
          return true;
        }
        else{
          return false;
        }
      }
      else{
        return true;
      }
    }

    useEffect(()=>{
      if(varsAndFuncsFieldSampleChild.sample?.sub_opened){
        setOpen(true)
        varsAndFuncsFieldSampleChild.allSamps[varsAndFuncsFieldSampleChild.index].samples[varsAndFuncsFieldSampleChild.indexchild].sub_opened=true
      }
    },[varsAndFuncsFieldSampleChild.sample?.sub_opened, varsAndFuncsFieldSampleChild.allSamps, varsAndFuncsFieldSampleChild.indexchild, varsAndFuncsFieldSampleChild.index]);

    return (
      loading? (
        <div className='heightImportant'>
          <LoadingSpinner/>
        </div>
        ):(
          <React.Fragment>
          <Modal //Modal to open the Audit Log
            className="smooth-scrollbar"
            open={openAudit}
            onClose={handleCloseAudit}
          >
            <div>
              <IconButton aria-label='close' style={{ left: '73.5%', top: '7%', position: 'absolute', cursor: 'pointer' }} onClick={() => { setOpenAudit(false) }}>
                <CloseIcon style={{ color: 'white' }} />
              </IconButton>
              <Box sx={modalStyle} className="smooth-scrollbar removePadding">
                <AuditLog open={openAudit} setOpen={setOpenAudit} sample ={varsAndFuncsFieldSampleChild.sample}/>
              </Box>
            </div>
          </Modal>
          <StyledTableRow2 key={varsAndFuncsFieldSampleChild.sample.siteName}>
            <StyledTableCell component="th" scope="row" tabIndex={0}>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => { openSubSample()}}
              >
                {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
              </IconButton>
              <span style={{ display:'none'}}>Expandable</span>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" style={{ fontWeight: 700 }} className="text-align-override" tabIndex={0}>
              {moment.tz(varsAndFuncsFieldSampleChild.sample.sample, state.userTimeZone.id[0]).format('MM/DD/YYYY')}
            </StyledTableCell>
            <StyledTableCell style={{ fontWeight: 700 }} className="text-align-override" tabIndex={0}>{`${moment.tz(varsAndFuncsFieldSampleChild.sample.sample, state.userTimeZone.id[0]).format('HH:ss')} ${state.userTimeZone.code}`}</StyledTableCell>
            <StyledTableCell style={{ fontWeight: 700 }} className="text-align-override" tabIndex={0}>{RoundDecimal2(varsAndFuncsFieldSampleChild.sample.sample_average_value)+` %`}</StyledTableCell>
            <StyledTableCell style={{ fontWeight: 700 }} className="text-align-override" tabIndex={0}>
              {varsAndFuncsFieldSampleChild.sample.status}
            </StyledTableCell>
            <StyledTableCell  tabIndex={0}>
              {
                (!varsAndFuncsFieldSampleChild.sample.status.includes('Submitted') && !varsAndFuncsFieldSampleChild.siteInfo.siteStatus.includes('Inactive')) &&
                <Tooltip title={ "Submit Sample" } placement="top-start">

                  <Button variant="contained" 
                    style={{textTransform: 'none'}} 
                    onClick={()=>onSubmitSample(varsAndFuncsFieldSampleChild.sample)} 
                    disabled ={varsAndFuncsFieldSampleChild.sample.status.includes('Archived') || checkIfAllComplete()}>
                    Submit
                  </Button>
                </Tooltip>
              }
              
            </StyledTableCell>
            <StyledTableCell tabIndex={0}>
              {
                !varsAndFuncsFieldSampleChild.siteInfo.siteStatus.includes('Inactive') &&
                <Tooltip title={ "Delete Sample" } placement="top-start">
                  
                  <Button variant="outlined" color="error" 
                    style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white' }} 
                    onClick={()=>onDeleteSample(varsAndFuncsFieldSampleChild.sample,varsAndFuncsFieldSampleChild.index,varsAndFuncsFieldSampleChild.indexchild)} 
                    disabled={varsAndFuncsFieldSampleChild.sample.status.includes('Archived')}>
                    <DeleteIcon/>
                  </Button>
                </Tooltip>
              }
            </StyledTableCell>
            {
              state.user && fieldSampleAreaEditor(state.user) && 
              <StyledTableCell>
                <Tooltip title="Fuel Settings">
                  <IconButton
                    onClick={ handleOpenAudit}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                  >
                    <i className="fa fa-ellipsis-h" style={{ color: 'rgba(0, 0, 0, 0.87)' }} />
                  </IconButton>
              </Tooltip>
            </StyledTableCell>
            }
          </StyledTableRow2>
  
  
          <StyledTableRow2 >
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Table size="small" aria-label="subsamples" component={Paper}>
                    <colgroup>
                      <col width="11%" />
                      <col width="11%" />
                      <col width="11%" />
                      <col width="11%" />
                      <col width="11%" />
                      <col width="11%" />
                      <col width="11%" />
                      <col width="17%" />
                      <col width="3%" />
                      <col width="3%" />
  
                    </colgroup>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell2 className="text-align-override padding5">CONTAINER #</StyledTableCell2>
                        <StyledTableCell2 className="text-align-override padding5">WET WEIGHT(g)</StyledTableCell2>
                        <StyledTableCell2 className="text-align-override padding5">DRY WEIGHT(g)</StyledTableCell2>
                        <StyledTableCell2 className="text-align-override padding5">TARE WEIGHT(g)</StyledTableCell2>
                        <StyledTableCell2 className="text-align-override padding5">VALUE</StyledTableCell2>
                        <StyledTableCell2 className="text-align-override padding5">SUB SAMPLE STATUS</StyledTableCell2>
                        <StyledTableCell2 className="text-align-override padding5">ENTERED DATE</StyledTableCell2>
                        <StyledTableCell2 className="text-align-override padding5">LAST MODIFIED DATE</StyledTableCell2>
                        <td key ={`style-subsample-edit-button`} style={{padding: 'checkbox'}} className="headerDark" >&nbsp;</td>
                        <td key ={`style-subsample-delete-button`} style={{padding: 'checkbox'}} className="headerDark" >&nbsp;</td>
  
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {subSamples.map((subsamp, indexSub) => (
                        subsamp.sub_editing? (
                          /* If sub-sample editing is true then make it an edit field with values still present*/
                          <TableRow key={subsamp.fuel_sub_sample_id}>
                             <TableCell className="text-align-override padding5" component="th" scope="row" tabIndex={0}>
                              <TextField type="text" size='small' id={`${varsAndFuncsFieldSampleChild.index}-container-num`} placeholder="Container #" 
                                variant="outlined" 
                                className={'weightTextField'}
                                label="Container #"
                                InputLabelProps={{
                                  shrink:true,
                                  style:{visibility: 'hidden', width: 0}
                                }}
                                value={subsamp.container_id===''?'': subsamp.container_id} 
                                InputProps={{
                                  inputProps: {
                                    maxLength: 3
                                  }
                                }}
                                onInput={(e:any) => {
                                  if(e.target.value===1 && /^\s/.test(e.target.value)){
                                    return
                                  }
                                  validateCharacters(e, ValidCharacters.Alpha, ValidCharacters.Numeric)}
                                }
                                onChange={(e)=>{
                                  updateInputSub(setSubSamples, subSamples, indexSub, e.target.value, 'container_id')}
                                }
                              />
                            </TableCell>
                            <TableCell className="text-align-override padding5" component="th" scope="row" tabIndex={0}>
                              <TextField type="number" size='small' id={`${varsAndFuncsFieldSampleChild.index}-wet-weight`} placeholder="Input Weight" 
                                variant="outlined" value={subsamp.wet_weight===''?null: subsamp.wet_weight} 
                                className={'weightTextField'}
                                InputProps={{
                                  inputProps: { min: 0 }
                                }}
                                label="Wet Weight"
                                InputLabelProps={{
                                  shrink:true,
                                  style:{visibility: 'hidden', width: 0}
                                }}
                                error={subsamp.error_wet.length>1}
                                helperText={subsamp?.error_wet}
                                onKeyDown={preventMinus}
                                disabled={(varsAndFuncsFieldSampleChild.sample?.method_type && varsAndFuncsFieldSampleChild.sample?.method_type?.includes('Moisture Probe')) 
                                  ||
                                  (subsamp.sample_average_value && !subsamp.wet_weight && !subsamp.dry_weight && !subsamp.tar_weight)? true: false
                                }
                                onChange={(e)=>updateInputSub(setSubSamples, subSamples, indexSub, e.target.value, 'wet_weight')}/>
                            </TableCell>
                            <TableCell className="text-align-override padding5" tabIndex={0}>
                              <TextField type="number" size='small' id={`${varsAndFuncsFieldSampleChild.index}-dry-weight`} placeholder="Input Weight" 
                                variant="outlined" value={subsamp.dry_weight===''?null: subsamp.dry_weight} 
                                InputProps={{
                                  inputProps: { min: 0 }
                                }}
                                className={'weightTextField'}
                                InputLabelProps={{
                                  shrink:true,
                                  style:{visibility: 'hidden', width: 0}
                                }}
                                helperText={subsamp?.error_dry}
                                error={subsamp.error_dry.length>1}
                                label="Dry Weight"
                                onKeyDown={preventMinus}
                                disabled={(varsAndFuncsFieldSampleChild.sample?.method_type && varsAndFuncsFieldSampleChild.sample?.method_type?.includes('Moisture Probe'))||(subsamp.sample_average_value && !subsamp.wet_weight && !subsamp.dry_weight && !subsamp.tar_weight)? true: false}
                                onChange={(e)=>updateInputSub(setSubSamples, subSamples, indexSub, e.target.value, 'dry_weight')}/>
                            </TableCell>
                            <TableCell className="text-align-override padding5" tabIndex={0}>
                              <TextField type="number" size='small' id={`${varsAndFuncsFieldSampleChild.index}-tar-weight`} placeholder="Input Weight" 
                                variant="outlined" value={subsamp.tar_weight===''?null: subsamp.tar_weight} 
                                InputProps={{
                                  inputProps: { min: 0 }
                                }}
                                label="Tare Weight"
                                className={'weightTextField'}
                                InputLabelProps={{
                                  shrink:true,
                                  style:{visibility: 'hidden', width: 0}
                                }}
                                helperText={subsamp?.error_tare}
                                error={subsamp.error_tare.length>1}
                                onKeyDown={preventMinus}
                                disabled={(varsAndFuncsFieldSampleChild.sample?.method_type && varsAndFuncsFieldSampleChild.sample?.method_type?.includes('Moisture Probe'))||
                                (subsamp.sample_average_value && !subsamp.wet_weight && !subsamp.dry_weight && !subsamp.tar_weight)? true: false}
                                onChange={(e)=>updateInputSub(setSubSamples, subSamples, indexSub, e.target.value, 'tar_weight')}/>
                            </TableCell>
                            <TableCell className="text-align-override padding5" tabIndex={0}>
                              <TextField type="number" size='small' id={`${varsAndFuncsFieldSampleChild.index}-value`} placeholder="Input Value" 
                                variant="outlined" value={subsamp.sample_average_value} 
                                InputProps={{
                                  inputProps: { min: 0 }
                                }}
                                className={subsamp.error_value.length>1?('weightTextField .Mui-error'):'weightTextField'}
                                InputLabelProps={{
                                  shrink:true,
                                  style:{visibility: 'hidden', width: 0}
                                }}
                                label="Sub-Sample Value"
                                onKeyDown={preventMinus}
                                error={subsamp.error_value.length>1}
                                helperText={subsamp?.error_value}
                                disabled={(subsamp.wet_weight || subsamp.dry_weight || subsamp.tar_weight)? true: false}
                                onChange={(e)=>updateInputSub(setSubSamples, subSamples, indexSub, e.target.value, 'sample_average_value')}/>
                            </TableCell>
                            <TableCell className="text-align-override padding5" tabIndex={0}>{subsamp.sample_average_value?.length ===0? 'Draft': subsamp.status}</TableCell>

                            <TableCell className="text-align-override padding5">
                              {subsamp.created_time? moment(subsamp.created_time).format('MM/DD/YYYY'):''}
                            </TableCell>
                            <TableCell className="text-align-override padding5">
                              {subsamp.modified_time? moment(subsamp.modified_time).format('MM/DD/YYYY'): ''}
                            </TableCell>
                            <TableCell className='padding5' tabIndex={0}>
                              {
                                subsamp.sample_average_value ? (
                                  !varsAndFuncsFieldSampleChild.siteInfo.siteStatus.includes('Inactive') &&
                                  <Tooltip title={ "Save Single Sub-Sample" } placement="top-start">

                                    <Button key={varsAndFuncsFieldSampleChild.index} variant="contained" 
                                      style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', height: '30px'}} 
                                      disabled={error}
                                      onClick={() => handleDoneEdit(subsamp, varsAndFuncsFieldSampleChild.index, varsAndFuncsFieldSampleChild.indexchild, indexSub)}>
                                      <DoneIcon />
                                    </Button>
                                  </Tooltip>
                                ):(
                                  !varsAndFuncsFieldSampleChild.siteInfo.siteStatus.includes('Inactive') &&
                                  <Tooltip title={ "Save Single Sub-Sample" } placement="top-start" tabIndex={0}>

                                    <Button id ={subsamp.fuel_sub_sample_id} value={subsamp} variant="outlined" 
                                      style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white', height: '30px' }}
                                      onClick={() => handleDoneEdit(subsamp, varsAndFuncsFieldSampleChild.index, varsAndFuncsFieldSampleChild.indexchild, indexSub)}
                                      disabled={(!subsamp.sample_average_value && !subsamp.wet_weight && !subsamp.dry_weight && !subsamp.tar_weight) || error}
                                    >
                                      <SaveIcon id={subsamp.fuel_sub_sample_id}/>
                                    </Button>
                                  </Tooltip>
                                )
                              }
  
                            </TableCell>
                            <TableCell>
                              {
                                !varsAndFuncsFieldSampleChild.siteInfo.siteStatus.includes('Inactive') &&
                                <Tooltip title={ "Cancel Editing of Single Sub-Sample" } placement="top-start">

                                  <Button key ={varsAndFuncsFieldSampleChild.index} variant="outlined" color="error" 
                                    style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white', height: '30px' }}
                                    onClick={() => cancelEditing(varsAndFuncsFieldSampleChild.index, varsAndFuncsFieldSampleChild.indexchild, indexSub, setSubSamples, subSamples, subsamp)}
                                  >
                                    <CloseIcon key ={varsAndFuncsFieldSampleChild.index}/>
                                  </Button>
                                </Tooltip>
                              }
                            </TableCell>
  
                          </TableRow>
                        ):(
                          /*if the sub_editing is false then make it a read only */
                          <TableRow key={subsamp.fuel_sub_sample_id}>
                            <TableCell className={subsamp.container_id?`text-align-override padding5`:`text-align-override padding5 emptyContainer`} component="th" scope="row" tabIndex={0}>
                              {subsamp.container_id? subsamp.container_id:'none'}
                            </TableCell>
                            <TableCell className="text-align-override padding5" component="th" scope="row" tabIndex={0}>
                              {subsamp.wet_weight}
                            </TableCell>
                            <TableCell className="text-align-override padding5" tabIndex={0}>{subsamp.dry_weight}</TableCell>
                            <TableCell className="text-align-override padding5" tabIndex={0}>{subsamp.tar_weight}</TableCell>
                            <TableCell className="text-align-override padding5" tabIndex={0}>
                              {Number.isNaN(Number(subsamp.sample_average_value)) || subsamp.sample_average_value===null? '0%':`${Number(subsamp.sample_average_value).toFixed(2)}%`}
                            </TableCell>
                            <TableCell className="text-align-override padding5" tabIndex={0}>{subsamp.status}</TableCell>
                            <TableCell className="text-align-override padding5" component="th" scope="row" tabIndex={0}>
                              {subsamp.created_time? moment(subsamp.created_time).format('MM/DD/YYYY'):''}
                            </TableCell>
                            <TableCell className="text-align-override padding5" component="th" scope="row" tabIndex={0}>
                              {subsamp.modified_time? moment(subsamp.modified_time).format('MM/DD/YYYY'): ''}
                            </TableCell>
                            <TableCell className='padding5'>
                              {!varsAndFuncsFieldSampleChild.siteInfo.siteStatus.includes('Inactive') &&
                              <Tooltip title={ "Edit Sub-Sample" } placement="top-start">

                                <Button id ={subsamp.fuel_sub_sample_id} value={subsamp} variant="outlined" 
                                  style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white', height: '30px' }}
                                  onClick={()=>editSubSample(varsAndFuncsFieldSampleChild.index, varsAndFuncsFieldSampleChild.indexchild, indexSub, setSubSamples, subSamples)}
                                  disabled ={subsamp.status.includes('Archived')}>
                                  <EditIcon id={subsamp.fuel_sub_sample_id}/>
                                </Button>
                              </Tooltip>
                              }
                            </TableCell>
                            <TableCell>
                              {!varsAndFuncsFieldSampleChild.siteInfo.siteStatus.includes('Inactive') &&
                              <Tooltip title={ "Delete Sub-Sample" } placement="top-start">

                                <Button id ={subsamp.fuel_sub_sample_id} 
                                  variant="outlined" color="error" 
                                  style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white',  height: '30px'}} 
                                  onClick={() =>onDeleteSubSample(subsamp,varsAndFuncsFieldSampleChild.index,varsAndFuncsFieldSampleChild.indexchild)}
                                  disabled ={subsamp.status.includes('Archived')}
                                  >
                                  <DeleteIcon />
                                </Button>
                              </Tooltip>
                              }
                            </TableCell>
  
                          </TableRow>
                        )
                       
                      ))}
                    </TableBody>
                  </Table>
                  {
                    (!varsAndFuncsFieldSampleChild.siteInfo?.siteStatus.includes('Inactive') )&& 
                    <Grid row gap="md" style={{paddingTop: '10px'}}>
                      <Grid desktop={{col: 7}} style={{display: 'flex', justifyContent:'end'}}>
                        <Button variant="text" key ={varsAndFuncsFieldSampleChild.sample.fuel_sample_id} 
                          onClick={()=>addSubSample(subSamples,varsAndFuncsFieldSampleChild.index, varsAndFuncsFieldSampleChild.indexchild, setSubSamples)} 
                          style={{textTransform: 'none', textDecoration: 'underline'}}
                          disabled={varsAndFuncsFieldSampleChild.sample.status.includes('Archived')}>
                          <AddIcon fontSize='small'/>
                          Add Sub Sample
                        </Button>
                      </Grid>
                      <Grid desktop={{col:4}} style={{display: 'flex', justifyContent:'end'}}>
                        <Tooltip title={ "Save All Sub-Samples in this sample" } placement="top-start">
                            <Button variant="contained" key ={"save all"} 
                              onClick={()=>saveAllSubSamples(varsAndFuncsFieldSampleChild.index, varsAndFuncsFieldSampleChild.indexchild)} 
                              style={{textTransform: 'none'}}
                              disabled={varsAndFuncsFieldSampleChild.sample.status.includes('Archived') || error}
                            >
                              <DoneIcon fontSize='small'/>
                              Save All
                            </Button>
                          </Tooltip>
                      </Grid>

                    </Grid>
                  }
  
                </Box>
              </Collapse>
            </TableCell>
          </StyledTableRow2 >
  
        </React.Fragment>
        )
    );
  }